module.exports = __webpack_public_path__ + "static/media/icon_target_white.2ff2fe30.png";